const translations = {
  en: {
    title: 'Primary Billing Info',
    firstNameLabel: 'FirstName:',
    firstNamePlaceholder: 'FirstName',
    lastNameLabel: 'LastName:',
    lastNamePlaceholder: 'LastName',
    secondLastNameLabel: 'SecondLastName:',
    secondLastNamePlaceholder: 'SecondLastName',
    phoneLabel: 'Phone:',
    phonePlaceholder: 'Phone',
    emailLabel: 'EmailAddress:',
    emailPlaceholder: 'EmailAddress',
    cityLabel: 'City:',
    cityPlaceholder: 'City',
    addressLabel: 'Address:',
    addressPlaceholder: 'Address',
    zipCodeLabel: 'ZipCode:',
    zipCodePlaceholder: 'ZipCode',
    birthdateLabel: 'Birthdate:',
    countryLabel: 'Country:',
    stateLabel: 'State:',
    currencyLabel: 'Currency:',
    idLabel: 'ID / Cedula:',
    idPlaceholder: 'ID / Cedula',
    submit: 'Submit',
    warning: 'Warning',
    error: 'Error',
    invalidDob: 'Invalid Date of Birth.',
    fillRequired: 'Please fill all required values',
  },
  es: {
    title: 'Información de Facturación Principal',
    firstNameLabel: 'Nombre:',
    firstNamePlaceholder: 'Nombre',
    lastNameLabel: 'Apellido:',
    lastNamePlaceholder: 'Apellido',
    secondLastNameLabel: 'Segundo Apellido:',
    secondLastNamePlaceholder: 'Segundo Apellido',
    phoneLabel: 'Teléfono:',
    phonePlaceholder: 'Teléfono',
    emailLabel: 'Correo Electrónico:',
    emailPlaceholder: 'Correo Electrónico',
    cityLabel: 'Ciudad:',
    cityPlaceholder: 'Ciudad',
    addressLabel: 'Dirección:',
    addressPlaceholder: 'Dirección',
    zipCodeLabel: 'Código Postal:',
    zipCodePlaceholder: 'Código Postal',
    birthdateLabel: 'Fecha de Nacimiento:',
    countryLabel: 'País:',
    stateLabel: 'Estado:',
    currencyLabel: 'Moneda:',
    idLabel: 'ID / Cédula:',
    idPlaceholder: 'ID / Cédula',
    submit: 'Enviar',
    warning: 'Advertencia',
    error: 'Error',
    invalidDob: 'Fecha de Nacimiento Inválida.',
    fillRequired: 'Por favor complete todos los campos requeridos',
  },
  pt: {
    title: 'Informações Principais de Cobrança',
    firstNameLabel: 'Nome:',
    firstNamePlaceholder: 'Nome',
    lastNameLabel: 'Sobrenome:',
    lastNamePlaceholder: 'Sobrenome',
    secondLastNameLabel: 'Segundo Sobrenome:',
    secondLastNamePlaceholder: 'Segundo Sobrenome',
    phoneLabel: 'Telefone:',
    phonePlaceholder: 'Telefone',
    emailLabel: 'Endereço de E-mail:',
    emailPlaceholder: 'Endereço de E-mail',
    cityLabel: 'Cidade:',
    cityPlaceholder: 'Cidade',
    addressLabel: 'Endereço:',
    addressPlaceholder: 'Endereço',
    zipCodeLabel: 'CEP:',
    zipCodePlaceholder: 'CEP',
    birthdateLabel: 'Data de Nascimento:',
    countryLabel: 'País:',
    stateLabel: 'Estado:',
    currencyLabel: 'Moeda:',
    idLabel: 'ID / Documento:',
    idPlaceholder: 'ID / Documento',
    submit: 'Enviar',
    warning: 'Aviso',
    error: 'Erro',
    invalidDob: 'Data de Nascimento Inválida.',
    fillRequired: 'Por favor preencha todos os campos obrigatórios',
  },
}

export default translations
